import ZkOperateBar from './src/main'
ZkOperateBar.install = function (Vue) {
  Vue.component(ZkOperateBar.name, ZkOperateBar)
}
export default ZkOperateBar



// WEBPACK FOOTER //
// ./src/cdpBase/baseComponents/operateBar/index.js